export default __webpack_public_path__ + "static/media/ColorLogo.f437f23a.png";